<template>
    <div class="ml-5 mb-5">
        <label v-if="has_logo == 1" class="form-label">Logo</label>
        <label v-if="has_bg == 1" class="form-label">Illustration</label>
        <div class="bloc_image">
            <div class="bg_image_bloc">
                <div v-show="this.tmp_bg != '' || this.tmp_logo != ''" class="no_display_upload_image" :style="backgroundStyle">
                    <div class="display_group_button">
                        <button
                            :id="'left_' + index + (has_logo == 1 ? '_logo' : '') + (has_bg == 1 ? '_bg' : '')"
                            :ref="'left_' + index + (has_logo == 1 ? '_logo' : '') + (has_bg == 1 ? '_bg' : '')"
                            @click="triggerImageUpload($event, index)"
                            style="cursor: pointer"
                            type="button"
                            class="btn1"
                        >
                            <div class="bgbtn1">
                                <div class="post_bgbtn1">
                                    <img :src="bloc_image_1" alt="Logo" />
                                </div>
                            </div>
                        </button>
                        <button
                            :id="'download_' + index + (has_logo == 1 ? '_logo' : '') + (has_bg == 1 ? '_bg' : '')"
                            :ref="'download_' + index + (has_logo == 1 ? '_logo' : '') + (has_bg == 1 ? '_bg' : '')"
                            style="cursor: pointer"
                            type="button"
                            @click="donwload_img($event, index)"
                            class="btn1"
                        >
                            <div class="bgbtn1">
                                <div class="post_bgbtn1">
                                    <img :src="bloc_image_2" alt="Logo" />
                                </div>
                            </div>
                        </button>
                        <button
                            :id="'trush_' + index + (has_logo == 1 ? '_logo' : '') + (has_bg == 1 ? '_bg' : '')"
                            :ref="'trush_' + index + (has_logo == 1 ? '_logo' : '') + (has_bg == 1 ? '_bg' : '')"
                            style="cursor: pointer"
                            type="button"
                            @click="deleteTempFile($event, index)"
                            class="btn1"
                        >
                            <div class="bgbtn1">
                                <div class="post_bgbtn1">
                                    <img :src="bloc_image_3" alt="Logo" />
                                </div>
                            </div>
                        </button>
                    </div>
                </div>
                <div v-show="this.tmp_bg == '' && this.tmp_logo == ''" class="upload_image_display">
                    <span class="icon_image_bloc">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M21.3338 21.334L16.0004 16.0006M16.0004 16.0006L10.6671 21.334M16.0004 16.0006V28.0006M27.1871 24.5206C28.4876 23.8117 29.5149 22.6898 30.1069 21.3321C30.699 19.9745 30.8221 18.4583 30.4567 17.0229C30.0914 15.5875 29.2584 14.3146 28.0893 13.4052C26.9202 12.4958 25.4816 12.0016 24.0004 12.0006H22.3204C21.9169 10.4396 21.1646 8.99041 20.1204 7.76195C19.0761 6.5335 17.7669 5.55776 16.2912 4.90811C14.8156 4.25845 13.2118 3.95177 11.6006 4.01114C9.98935 4.0705 8.41252 4.49436 6.98867 5.25085C5.56482 6.00734 4.33098 7.07677 3.37993 8.37874C2.42888 9.68071 1.78536 11.1813 1.49774 12.7678C1.21013 14.3543 1.28591 15.9853 1.71939 17.5383C2.15286 19.0913 2.93276 20.5258 4.00044 21.734"
                                stroke="#7D2DBD"
                                stroke-width="2.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </span>
                    <span class="image_text_1">Choisissez le fichier à télécharger</span>
                    <span class="image_text_2">Format: .jpeg, .png & Max: 2 MB</span>
                    <label
                        class="btn_upload_image text_button_upload_image icon_upload_image ppv2-mt-2"
                        v-if="has_logo == 1 || has_bg == 1"
                        :for="'imageUpload_page_' + index + (has_logo == 1 ? '_logo' : '') + (has_bg == 1 ? '_bg' : '')"
                    >
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M7 2.91797V11.0846"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M2.9165 7H11.0832"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        Ajouter
                    </label>
                    <input
                        type="file"
                        v-if="has_logo == 1 || has_bg == 1"
                        :id="'imageUpload_page_' + index + (has_logo == 1 ? '_logo' : '') + (has_bg == 1 ? '_bg' : '')"
                        :ref="'imageUpload_page_' + index + (has_logo == 1 ? '_logo' : '') + (has_bg == 1 ? '_bg' : '')"
                        @change="handleImageUpload($event, info_page.title_page, has_bg == 1 ? true : false)"
                        class="form-control d-none"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['index', 'info_page', 'has_logo', 'has_bg'],
    data() {
        return {
            bloc_image_1: window.location.origin + '/media/bo/icons/left.png',
            bloc_image_2: window.location.origin + '/media/bo/icons/download.png',
            bloc_image_3: window.location.origin + '/media/bo/icons/trash.png',
            tmp_logo: '',
            tmp_bg: '',
        }
    },
    methods: {
        size_file(file) {
            const maxSize = 2 * 1024 * 1024 // 2MB in bytes

            if (file.size > maxSize) {
                alert("La taille de l'image doit être inférieure à 2 Mo")
                event.target.value = '' // Clear the input

                return false
            }
            return true
        },
        handleImageUpload(event, page, ajax) {
            const file = event.target.files[0]

            if (this.size_file(file)) {
                const id = event.target.id
                let has_bg = 0 // Declare with let outside the blocks
                if (id.indexOf('_bg') !== -1) {
                    has_bg = 1
                } else {
                    has_bg = 0
                }
                if (file) {
                    const reader = new FileReader()
                    reader.onload = (e) => {
                        const pageIndex = parseInt(id.match(/page_(\d+)/)[1])
                        this.info_page.image = e.target.result
                        this.info_page.tmp_image = e.target.result
                        if (has_bg == 1) {
                            this.tmp_bg = e.target.result
                        } else {
                            this.tmp_logo = e.target.result
                        }
                        if (ajax) {
                            this.$emit('disable-button')
                            this.$emit('image-uploaded', { index: pageIndex, image: '', has_bg: has_bg })
                            axios
                                .post('/back-office/generate_page/convert_image', {
                                    image: e.target.result,
                                    page: page,
                                    ajax: ajax,
                                })
                                .then((response) => {
                                    this.tmp_bg = response.data.path
                                    this.$emit('image-uploaded', { index: pageIndex, image: response.data.path, has_bg: has_bg })
                                    this.$emit('enable-button')
                                })
                                .catch((error) => {})
                        } else {
                            this.$emit('image-uploaded', { index: pageIndex, image: e.target.result, has_bg: has_bg })
                        }
                    }
                    reader.readAsDataURL(file)
                }
            }
        },
        donwload_img(event, index) {
            let img = ''
            if (event.currentTarget.id.indexOf('_bg') !== -1) {
                img = this.tmp_bg
            } else {
                img = this.tmp_logo
            }
            const link = document.createElement('a')
            link.href = img
            link.setAttribute('download', 'image.jpg') // set a default filename
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
        deleteTempFile(event, index) {
            if (event.currentTarget.id.indexOf('_bg') !== -1) {
                this.tmp_bg = ''
            } else {
                this.tmp_logo = ''
            }
        },
        triggerImageUpload(event, index) {
            let refName = ''
            if (this.has_logo == 1) {
                refName = 'imageUpload_page_' + index + '_logo'
            }
            if (this.has_bg == 1) {
                refName = 'imageUpload_page_' + index + '_bg'
            }
            const input = this.$refs[refName]

            if (input && input.length) {
                input[0].click() // ref inside v-for becomes an array
            } else if (input) {
                input.click() // if not an array, just click
            } else {
                console.warn('Ref not found:', refName)
            }
        },
    },
    computed: {
        backgroundStyle() {
            // No "return" here - this is the property definition
            if (this.has_logo === 1 && this.tmp_logo) {
                return {
                    backgroundImage: `url(${this.tmp_logo})`,
                    backgroundSize: 'cover',
                }
            } else if (this.has_bg === 1 && this.tmp_bg) {
                return {
                    backgroundImage: `url(${this.tmp_bg})`,
                    backgroundSize: 'cover',
                }
            }
            return {} // default empty style
        },
    },
}
</script>
<style scoped>
.icon_image_bloc {
    width: 32px;
    height: 32px;
}
.bg_image_bloc {
    border: 1px solid #7d2dbd;
    height: 200px;
    border-radius: 8px;
    border-width: 1px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 5px;
    background: #7d2dbd1a;
}
.bloc_image {
    border: 1px solid #e6e7ea;
    height: 248px;
    top: 672px;
    left: 24px;
    border-radius: 12px;
    border-width: 1px;
    padding: 24px;
    gap: 32px;
    box-shadow: 0px 8px 8px -4px #0a0d1208;
    box-shadow: 0px 20px 24px -4px #0a0d1214;
}
.image_text_2 {
    font-size: clamp(12px, 0.729545vw, 16px);
    line-height: 20px;
    letter-spacing: 0%;
}
.image_text_1 {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
}
.btn_upload_image {
    width: auto !important;
    height: 35px !important;
    top: 142px;
    left: 152px;
    border-radius: 12px;
    gap: 8px;
    padding-top: 8px;
    padding-right: 24px;
    padding-bottom: 8px;
    padding-left: 24px;
    background: #021832;
}
.text_button_upload_image {
    font-family:
        Poppins Regular,
        sans-serif;
    font-size: 12px;
    line-height: 140%;
    color: #ffffff;
}
.no_display_upload_image {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: 200px;
    border-radius: 8px;
    border-color: #fcedfd;
}
.icon_upload_image {
    top: 2.92px;
    left: 2.92px;
    width: 14px;
    height: 14px;
    color: #ffffff;
}
.post_bgbtn1 {
    position: static; /* plus besoin de top: -17px */
}

.post_bgbtn1 img {
    width: 16px; /* ou ajuster selon le besoin */
    height: 16px;
    object-fit: contain;
    border-radius: 0;
}
.bgbtn1 {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 2px solid #7d2dbd26;
    background-color: #7d2dbd26;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: -4px;
    left: -3px;
}
.btn1 {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    border-width: 1px;
    padding: 11px;
    margin-bottom: 10px;
    gap: 8px;
    border: 1px solid #e6e7ea;
    background-color: #ffffff;
}
.upload_image_display {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 5px;
}
.display_group_button {
    width: 40px;
    height: 136px;
    top: 23px;
    left: 90%;
    position: relative;
    gap: 8px;
}
.form-label {
    font-family: Poppins Regular;
    font-size: 18px;
    line-height: 140%;
    text-transform: unset;
    color: #021832;
}
.form-group {
    padding-bottom: 20px;
    padding-top: 20px;
}

.ml-5 {
    margin-left: 25px;
}

@media (max-width: 1280px) {
    .image_text_1,
    .image_text_2 {
        text-align: center !important;
    }
}
</style>
